import Popup from 'react-popup';
import { trackPopupOpenEvent, trackPopupCloseEvent } from '../analytics/screenEventAnalytics';
import { v4 as uuid } from 'uuid';
import { EventEmitter } from 'events';

let lastPopupType = null;
const PopupEvents = new EventEmitter();

export const closePopup = () => {
  trackPopupCloseEvent(lastPopupType);
  Popup.close();
};

export const createPopup = (params) => {
  const id = uuid();
  const { type, onClose, onOpen } = params;
  lastPopupType = type;
  trackPopupOpenEvent(type);
  const popupParams = Object.assign({}, params, {
    onOpen: () => {
      PopupEvents.on(`${id}:close`, closePopup);

      if (type) {
        PopupEvents.on(`${type}:close`, closePopup);
      }

      if (onOpen && typeof onOpen === 'function') {
        onOpen();
      }
    },
    onClose: () => {
      PopupEvents.off(`${id}:close`, closePopup);

      if (type) {
        PopupEvents.off(`${type}:close`, closePopup);
      }

      if (onClose && typeof onClose === 'function') {
        onClose();
      }
    },
  });

  delete popupParams.type;

  Popup.create(popupParams);

  return id;
};

export const closePopupByIdOrType = (id) => {
  PopupEvents.emit(`${id}:close`);
};
